import React, { useEffect, useState } from 'react';
import { Flex } from '@spothero/ui';
import { whiteHeaderStyles } from 'common/header/headerStyles';
import { CompanyLogo } from 'common/navigation/icons';
import { SearchHeaderDropdown } from './dropdown/SearchHeaderDropdown';
import { SearchComponentContainer } from '../search-component/SearchComponentContainer';
import { GoogleMapsProvider } from 'common/google-map-context';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import { useElementHeight } from 'hooks/use-element-height';
const HeaderSearchDesktop = () => {
    const [headerRef] = useElementHeight();
    const { parkingType } = useReduxSearchState();
    const [isClient, setIsClient] = useState(false);
    useEffect(() => setIsClient(true), []);
    return (<Flex ref={headerRef} {...whiteHeaderStyles} as="header" role="banner" data-testid="Header" justifyContent="space-between" sx={{
            // Make the CompanyLogo responsive
            '& .CompanyLogo': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                paddingX: 4,
            },
            '& .CompanyLogo .chakra-icon': {
                position: 'relative', // remove absolute positioning
                top: 0,
                left: 0,
                transform: 'none',
            },
            // The styles in the below block support the chakra 2 migration.  Its not recommended to lean on these styles long term.
            '& .InputAutocomplete': {
                zIndex: 1, // Ensure the input autocomplete is above date picker when it grows
                input: {
                    lineHeight: '24px',
                },
            },
            ...(parkingType === 'event' && {
                '& .SearchComponentContainer': {
                    maxWidth: { base: '80%', desktopXL: '60%' }, // Prevent Event Search Component Widget from taking too much space
                },
            }),
        }}>
            <CompanyLogo isWhiteHeader/>
            <GoogleMapsProvider>
                {isClient && <SearchComponentContainer />}
            </GoogleMapsProvider>
            <SearchHeaderDropdown />
        </Flex>);
};
export default HeaderSearchDesktop;
